<script>
    import { navigate } from "svelte-routing";
    export let token;
    export let subscriptionID;
    let phoneNumber;
    let code;
    let showLoginForm = true;
    // grab the query param and make a backend request
    function acceptInvite() {
        fetch(`/api/v1/invite/${token}/sub/${subscriptionID}`, {
            body: JSON.stringify({
                phoneNumber,
            }),
            method: 'POST',
        })
        .then(data => data.json())
        .then(() => {
            // now show a form with a code input
            showLoginForm = false;
        });
    };

    function loginConfirm() {
        fetch(`/api/v1/login-confirm`, {
            body: JSON.stringify({
                phoneNumber,
                code,
            }),
            method: 'POST',
        })
        .then(() => {
            navigate("/");
        });
    }
</script>

<div>
    {#if showLoginForm}
        <div>Enter your mobile number to accept this invite</div>

        <form id="accept-invite-form">
            <input bind:value={phoneNumber} class="input" type="text" name="PHONENUMBER" autocomplete="off" placeholder="Enter Mobile Number" data-required="true" required />
            <button on:click|preventDefault={acceptInvite} type="submit" form="accept-invite-form" class="primary">
                Go    
            </button>
        </form>
    {:else}
        <div>Confirm code you received on your mobile</div>
        <form id="confirm-login-form">
            <input bind:value={code} class="input" type="text" name="CODE" autocomplete="off" placeholder="Enter Code" data-required="true" required />
            <button on:click|preventDefault={loginConfirm} type="submit" form="confirm-login-form" class="primary">
                Go    
            </button>
        </form>
    {/if}
</div>